const variants = {
  primary: {
    solid: {
      enabled: {
        button: "border border-transparent bg-green text-white",
        icon: "white",
        loader: "bg-white",
      },
      disabled: {
        button: "border border-transparent bg-green-200 text-white",
        icon: "white",
        loader: "bg-white",
      },
    },
    outline: {
      enabled: {
        button:
          "border border-green text-green hover:text-white hover:bg-green",
        icon: "#4ABE82",
        loader: "bg-green-400",
      },
      disabled: {
        button: "border border-green-200 text-green-200",
        icon: "#D4F6E4",
        loader: "bg-green-200",
      },
    },
    ghost: {
      enabled: {
        button: "border border-transparent text-green",
        icon: "#4ABE82",
        loader: "bg-green-400",
      },
      disabled: {
        button: "border border-transparent text-green-200",
        icon: "#D4F6E4",
        loader: "bg-green-200",
      },
    },
  },
  danger: {
    solid: {
      enabled: {
        button: "border border-transparent bg-orange text-white",
        icon: "white",
        loader: "bg-white",
      },
      disabled: {
        button: "border border-transparent bg-orange-400 text-white",
        icon: "white",
        loader: "bg-white",
      },
    },
    outline: {
      enabled: {
        button:
          "border border-orange text-orange hover:text-white hover:bg-orange",
        icon: "#FD6E5E",
        loader: "bg-orange",
      },
      disabled: {
        button: "border border-orange-400 text-orange-400",
        icon: "#FFDEE9",
        loader: "bg-orange-400",
      },
    },
    ghost: {
      enabled: {
        button: "border border-transparent text-orange",
        icon: "#FD6E5E",
        loader: "bg-orange",
      },
      disabled: {
        button: "border border-transparent text-orange-400",
        icon: "#FFDEE9",
        loader: "bg-orange-400",
      },
    },
  },
  warning: {
    solid: {
      enabled: {
        button: "border border-transparent bg-yellow text-white",
        icon: "white",
        loader: "bg-white",
      },
      disabled: {
        button: "border border-transparent bg-yellow-400 text-white",
        icon: "white",
        loader: "bg-white",
      },
    },
    outline: {
      enabled: {
        button:
          "border border-yellow text-yellow hover:text-white hover:bg-yellow",
        icon: "#FFCC00",
        loader: "bg-yellow",
      },
      disabled: {
        button: "border border-yellow-400 text-yellow-400",
        icon: "#FFF7DD",
        loader: "bg-yellow-400",
      },
    },
    ghost: {
      enabled: {
        button: "border border-transparent text-yellow",
        icon: "#FFCC00",
        loader: "bg-yellow",
      },
      disabled: {
        button: "border border-transparent text-yellow-400",
        icon: "#FFF7DD",
        loader: "bg-yellow-400",
      },
    },
  },
  secondary: {
    solid: {
      enabled: {
        button: "border border-transparent bg-black-700 text-white",
        icon: "white",
        loader: "bg-white",
      },
      disabled: {
        button: "border border-transparent bg-gray-200 text-white",
        icon: "white",
        loader: "bg-white",
      },
    },
    outline: {
      enabled: {
        button:
          "border border-gray-200 text-black-700 hover:text-white hover:bg-black-700",
        icon: "#313131",
        loader: "bg-black-700",
      },
      disabled: {
        button: "border border-gray-300 text-gray-300",
        icon: "#E7E7E7",
        loader: "bg-gray-300",
      },
    },
    ghost: {
      enabled: {
        button: "border border-transparent text-black-700",
        icon: "#313131",
        loader: "bg-black-700",
      },
      disabled: {
        button: "border border-transparent text-gray-300",
        icon: "#E7E7E7",
        loader: "bg-gray-300",
      },
    },
  },
};

export default variants;
